module.exports = __webpack_public_path__ + "static/media/crow_fly_to_home.2933e033.gif";